export default "__VITE_ASSET__BsgpeXsJ__"